var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posterWrapper",class:this.posterPosition},[(
      _vm.posterState.layout == 'classic-svg' ||
        _vm.posterState.layout == 'straight-svg'
    )?_c('ClassicPoster',{attrs:{"poster-state":_vm.posterState,"sound-data":_vm.soundData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }